// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"451":"64b7a37a","453":"e1b20c8d"}[chunkId] + ".chunk.js";
};